import { Injectable } from '@angular/core';

import { MemoryCacheRepository } from './memory-cache.repository';
import { StreetTypeInterface } from '../data';

@Injectable()
export class StreetTypeCacheRepository extends MemoryCacheRepository<StreetTypeInterface[]> {}
